import React, { useEffect } from "react";
import { useAuth } from "../components/AuthContext";
import { useNavigate } from "react-router-dom";

const RequireAdmin = (WrappedComponent) => {
  const RequireAdminComponent = (props) => {
    const { user, isAdmin, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      // 로딩 중이 아닐 때만 권한 체크 및 리다이렉트 수행
      if (!loading) {
        if (!user) {
          navigate("/"); // 로그인하지 않은 경우 홈으로 (또는 로그인 페이지로)
          return;
        }

        if (!isAdmin) {
          alert("관리자 권한이 필요합니다.");
          navigate("/"); // 관리자가 아닌 경우 홈으로
        }
      }
    }, [user, isAdmin, loading, navigate]);

    // 로딩 중이거나 아직 권한 확인이 안 된 경우
    if (loading || (user && !isAdmin)) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mb-4"></div>
            <p className="text-gray-500 font-medium">관리자 권한 확인 중...</p>
          </div>
        </div>
      );
    }

    // 관리자임이 확인된 경우에만 컴포넌트 렌더링
    return <WrappedComponent {...props} />;
  };

  return RequireAdminComponent;
};

export default RequireAdmin;
